export default {
  validationSummaryTitle: 'Resumo de Validação do Template de Dados',
  close: 'Fechar',
  criticalErrorsTab: 'Erros Críticos',
  warningsTab: 'Avisos',
  fileStructureErrors: 'Erros de Estrutura de Arquivo',
  columnWideDataErrors: 'Erros de Dados em Colunas',
  rowSpecificDataErrors: 'Erros de Dados em Linhas Específicas',
  cellSpecificDataErrors: 'Erros de Dados em Células Específicas',
  affectedRowsList: 'lista de linhas afetadas',
  affectedCellsList: 'lista de células afetadas',
  onlyFirst50: '(apenas as primeiras 50)',
  row: 'linha',
  rows: 'linhas',
  cell: 'célula',
  cells: 'células',
  fileStructureWarnings: 'Avisos de Estrutura de Arquivo',
  columnWideDataWarnings: 'Avisos de Dados em Colunas',
  rowSpecificDataWarnings: 'Avisos de Dados em Linhas Específicas',
  uploadingFile: 'Enviando',
  cancel: 'Cancelar',
  instructionsTitle: 'Instruções de Upload de Dados',
  instructionsHeader: 'Instruções',
  instructionsIntro: 'Nesta seção, você pode enviar os dados necessários para treinar seu modelo de marketing mix. Siga estes passos:',
  instructionsStep1: 'Baixe o template de dados fornecido.',
  instructionsStep2: 'Preencha-o seguindo as instruções nas duas primeiras planilhas.',
  instructionsStep3: 'Envie a planilha preenchida usando o botão "Enviar Arquivo".',
  instructionsValidation: 'O sistema validará automaticamente o conteúdo do seu arquivo. Se for válido, você verá um',
  instructionsValidationContinue: 'em Resultados de Validação, então um Cientista de Dados o revisará manualmente e informaremos se tivermos alguma pergunta adicional sobre os dados.',
  instructionsIfFails: 'Se a validação automática falhar, significa que o sistema detectou problemas. Você pode clicar em',
  summaryReport: 'Relatório Resumo',
  instructionsReviewDetails: 'e revisar os problemas em detalhes. Há dois tipos de problemas:',
  criticalErrorsDescription: 'impedem que o treinamento do modelo seja realizado. Você deve corrigi-los e reenviar o arquivo.',
  warningsDescription: 'não necessariamente impedem o treinamento do modelo, mas você deve revisá-los cuidadosamente, corrigir o que parecer um erro e reenviar o arquivo. Se você acreditar que não são erros, pode ignorar os avisos.',
  dataBriefsUploadTitle: 'Upload de Briefs de Dados',
  dataBriefsCaption1: '1. Esta seção permite enviar documentos padrão de Brief com os requisitos do projeto. Por favor baixe uma cópia',
  dataBriefsCaption1Link: 'aqui',
  dataBriefsCaption2: '2. Estes arquivos serão revisados pela nossa equipe para entender seus requisitos de modelagem.',
  approvalStatus: 'Status de Aprovação',
  pending: 'Pendente',
  dataBriefHeader: 'Brief de Dados',
  uploadedOnHeader: 'Data de Upload',
  uploaderHeader: 'Enviado Por',
  actionsHeader: 'Ações',
  pleaseUploadDataBrief: 'Por favor envie seu brief de dados',
  approveBrief: 'Aprovar Brief',
  uploadDataBrief: 'Enviar Brief de Dados',
  dataTemplatesUploadTitle: 'Upload de Templates de Dados',
  dataTemplatesCaption1: '1. Esta seção só permite enviar templates de dados padrão. Por favor baixe uma cópia',
  dataTemplatesCaption2: '2. Leia as instruções completas sobre como usar o uploader e interpretar os resultados',
  dataFileHeader: 'Arquivo de Dados',
  validationResultsHeader: 'Resultados de Validação',
  validatingFile: 'Validando arquivo',
  noErrorsFound: 'Nenhum erro encontrado',
  criticalError: 'erro crítico',
  criticalErrors: 'erros críticos',
  warning: 'aviso',
  warnings: 'avisos',
  fixErrorsFirst: 'Corrigir Erros Primeiro',
  approveData: 'Aprovar Dados',
  pleaseUploadData: 'Por favor envie seus dados',
  uploadFile: 'Enviar Arquivo',
  unsupportedFileType: 'Tipo de arquivo MIME não suportado',
  errorUploadingFile: 'Erro ao enviar o arquivo.',
  dataCheckDialogTitle: 'Template aprovado. Quer revisar seus dados?',
  dataCheckDialogText: 'A Revisão de Dados mostra seu template em gráficos simples, para você encontrar períodos faltantes, picos ou datas deslocadas antes de começar a modelagem.',
  dataCheckDialogLater: 'Mais tarde',
  dataCheckDialogGo: 'Ir para Revisão de Dados'
}
